export const Colors = {
  primary: "#255a61",
  secondary: "#56acb7",
  context: "#f1f1f1",
  black: "#000000",
};
